const CreditScoreList = {
    ratetable: [
        { text: 'Excellent (740+)', value: '2' },
        { text: 'Good (700-739)', value: '4' },
        { text: 'Fair (660-699)', value: '6' },
        { text: 'Poor (580-659)', value: '8' },
    ],
    student: [
        { text: '> 769 (Excellent)', value: 1 },
        { text: '740-769 (Excellent)', value: 2 },
        { text: '720-739 (Good)', value: 3 },
        { text: '700-719 (Good)', value: 4 },
        { text: '680-699 (Fair)', value: 5 },
    ],
    ratetableauto: [
        { text: 'Excellent (720 +)', value: 'Excellent720OrMore' },
        { text: 'Good (680-719)', value: 'Good680To719' },
        { text: 'Fair (640-679)', value: 'Fair640To679' },
        { text: 'Poor (< 639)', value: 'Poor639OrLess' },
    ],
    ratetablepersonalloanv2: [
        { text: 'Excellent (720+)', value: 3 },
        { text: 'Good (680-719)', value: 2 },
        { text: 'Fair (640-679)', value: 1 },
        { text: 'Poor (< 640)', value: 0 },
    ],
    homeaffordability: [
        { text: '760-850 (Excellent)', value: 1 },
        { text: '740-759 (Excellent)', value: 2 },
        { text: '720-739 (Good)', value: 3 },
        { text: '700-719 (Good)', value: 4 },
        { text: '680-699 (Fair)', value: 5 },
        { text: '660-679 (Fair)', value: 6 },
        { text: '640-659 (Poor)', value: 7 },
        { text: '620-639 (Poor)', value: 8 },
        { text: '580-619 (Poor)', value: 9 },
        { text: '580 (Poor)', value: 10 },
    ],
    autoloan: [
        { text: 'Excellent (680+)', value: 1 },
        { text: 'Good (620-679)', value: 2 },
        { text: 'Fair (560-619)', value: 3 },
        { text: 'Poor (< 560)', value: 4 },
    ],
    oemfinancecrditscore: [
        { text: 'Excellent (800+)', value: 1 },
        { text: 'Good (720-739)', value: 2 },
        { text: 'Fair (680-699)', value: 3 },
        { text: 'Poor (580)', value: 4 },
    ],
    dailyMortgageTrend: [
        { text: '780+', value: '780-999' },
        { text: '740-779', value: '740-779' },
        { text: '700-739', value: '700-739' },
        { text: '660-699', value: '660-699' },
        { text: '580-659', value: '580-659' },

    ],
    businessLoanRefinance: [
        { text: 'Excellent (720+)', value: 1 },
        { text: 'Good (680-719)', value: 2 },
        { text: 'Fair (640-679)', value: 3 },
        { text: 'Poor (639 or less)', value: 4 },
    ],
    businessLoan: [
        { text: 'Excellent (720+)', value: 1 },
        { text: 'Good (680-719)', value: 2 },
        { text: 'Fair (640-679)', value: 3 },
        { text: 'Poor (639 or less)', value: 4 },
    ],
    debtManagementAdvisor: [
        { text: 'Excellent (>720)', value: 'Excellent' },
        { text: 'Good (660-719)', value: 'Good' },
        { text: 'Fair (600-659)', value: 'Fair' },
        { text: 'Poor (< 599)', value: 'Poor' },
    ],
    fhaLoan: [
        { text: '580-850', value: 1 },
        { text: '500-579', value: 2 },
        { text: '300-499', value: 3 },
    ],
    homeEquityLoan: [
        { text: '740+ (Excellent)', value: 'Excellent' },
        { text: '680-739 (Good)', value: 'Good' },
        { text: '620-679 (Fair)', value: 'Fair' },
        { text: '< 620 (Poor)', value: 'Poor' },
    ],
    mortgageRateTable: [
        { text: '780+', value: 'Excellent' },
        { text: '740-779', value: 'Excellent' },
        { text: '700-739', value: 'Good' },
        { text: '660-699', value: 'Fair' },
        { text: '580-659', value: 'Poor' },
    ],
    mortgagePurchaseCalculator: [
        { text: '<strong>Excellent</strong> (720-850)', value: 'Excellent' },
        { text: '<strong>Good</strong> (680-719)', value: 'Good' },
        { text: '<strong>Fair</strong> (640-679)', value: 'Fair' },
        { text: '<strong>Poor</strong> (0-639)', value: 'Poor' },
    ],
};

export default CreditScoreList;
